import { num, perDay } from "../format"
import type { Site } from "../types"

function Doc({ qty, move }: { qty: number; move: number }) {
  if (move <= 0) return <span className="font-semibold">No movement</span>
  return <>{num(Math.round(qty / move))}</>
}

// Stock per allocated warehouse with a total row: how much sits there, how
// much leaves it per day (sold plus gifted, last 90 days or since a new product first sold), and how many days
// that lasts.
export default function SitesTable({ sites }: { sites: Site[] }) {
  const total = {
    qty: sites.reduce((sum, s) => sum + s.qty, 0),
    move: sites.reduce((sum, s) => sum + s.out_per_day, 0),
  }

  return (
    <table className="w-full text-sm">
      <thead className="bg-muted/60 text-xs font-semibold uppercase tracking-wide">
        <tr>
          <th className="px-4 py-2 text-left">Warehouse</th>
          <th className="px-4 py-2 text-right">Qty</th>
          <th className="px-4 py-2 text-right">Avg Daily Stock Move</th>
          <th className="px-4 py-2 text-right">DOC</th>
        </tr>
      </thead>
      <tbody className="divide-y tabular-nums">
        {sites.map((site) => (
          <tr key={site.warehouse}>
            <td className="px-4 py-2 font-medium">{site.warehouse}</td>
            <td className="px-4 py-2 text-right">{num(site.qty)}</td>
            <td className="px-4 py-2 text-right">{perDay(site.out_per_day)}</td>
            <td className="px-4 py-2 text-right"><Doc qty={site.qty} move={site.out_per_day} /></td>
          </tr>
        ))}
        <tr className="border-t bg-muted/30 font-semibold">
          <td className="px-4 py-2">Total</td>
          <td className="px-4 py-2 text-right">{num(total.qty)}</td>
          <td className="px-4 py-2 text-right">{perDay(total.move)}</td>
          <td className="px-4 py-2 text-right"><Doc qty={total.qty} move={total.move} /></td>
        </tr>
      </tbody>
    </table>
  )
}
